const initialState = [
  {
    id: '1',
    category: 'Article',
    title: 'Boost your conversion rate',
    img: 'https://i.ibb.co/rxRVjS7/blog-Image-1.jpg',
    date: '11 Jul, 2022',
    authorName: 'Learn with sumit',
    read: '5 min read',
    authorImg: 'https://i.ibb.co/rxRVjS7/blog-Image-1.jpg',
  },
  {
    id: '2',
    category: 'Personal',
    title: 'How to use search engine optimization to drive sales',
    img: 'https://i.ibb.co/cLXNyPS/blog-Img-2.jpg',
    date: '11 Jul, 2022',
    authorName: 'Jhankar Mahabub',
    read: '5 min read',
    authorImg: 'https://i.ibb.co/rxRVjS7/blog-Image-1.jpg',
  },
  {
    id: '3',
    category: 'Article',
    title: 'Improve your customer experience',
    img: 'https://i.ibb.co/k6GK03N/blog-Img-3.jpg',
    date: '11 Jul, 2022',
    authorName: 'Sony Sangha',
    read: '5 min read',
    authorImg: 'https://i.ibb.co/rxRVjS7/blog-Image-1.jpg',
  },
  {
    id: '4',
    category: 'Article',
    title: 'Boost your conversion rate',
    img: 'https://i.ibb.co/8s8R9DL/blog-Img-4.jpg',
    date: '11 Jul, 2022',
    authorName: 'Mosh Hamedani',
    read: '5 min read',
    authorImg: 'https://i.ibb.co/rxRVjS7/blog-Image-1.jpg',
  },
  {
    id: '5',
    category: 'Nothing',
    title: 'How to use search engine optimization to drive sales',
    img: 'https://i.ibb.co/Mgq9dvq/blog-Img-5.jpg',
    date: '11 Jul, 2022',
    authorName: 'Learn with sumit',
    read: '5 min read',
    authorImg: 'https://i.ibb.co/rxRVjS7/blog-Image-1.jpg',
  },
  {
    id: '6',
    category: 'Nothing',
    title: 'Improve your customer experience',
    img: 'https://i.ibb.co/qC2TX2M/blog-Image-6.jpg',
    date: '11 Jul, 2022',
    authorName: 'Jhankar Mahabub',
    read: '5 min read',
    authorImg: 'https://i.ibb.co/rxRVjS7/blog-Image-1.jpg',
  },
];

const reducer = (state = initialState, action) => {
  // logics
  return state;
};
export default reducer;
